import { DemeterPermissionType } from '../../../Generated/Raven-Demeter';
import permissionsService from './PermissionsService';

const usePermission = (permission: DemeterPermissionType, subPermission?: string): boolean => permissionsService.getPermission(permission, subPermission);

export default usePermission;
